export default "__VITE_ASSET__CI2g8msP__"